
export const bidStatuses = {
  all: {
    value: 'all',
    name: 'Все',
    plural: 'Все',
    // textColor: '#737373',
    // icon: EditFilled,
    params: {}
  },
  new: {
    name: 'Черновик',
    textColor: '#B76E00',
    color: 'info',
    // color: 'rgba(255, 171, 0, 0.16)',
    params: {
      status: 'new',
      is_approved: true,
    },
  },
  accepted: {
    name: 'К выплате',
    textColor: '#B76E00',
    color: 'warning',
    // color: 'rgba(255, 171, 0, 0.16)',
    params: {
      status: 'accepted',
    }
  },
  invalid: {
    params: {
      status: undefined,
      is_valid: false
    }
  },
  valid: {
    params: {
      status: undefined,
      is_valid: true
    }
  },
  on_review: {
    name: 'На согласовании',
    textColor: '#B76E00',
    color: 'warning',
    // color: 'rgba(255, 171, 0, 0.16)',
    params: {
      status: 'new',
      is_approved: false,
    }
  },
  pending: {
    name: 'Обрабатывается в банке',
    textColor: '#B76E00',
    color: 'warning',
    // color: 'rgba(255, 171, 0, 0.16)',
    params: {
      status: 'pending',
    }
  },
  done: {
    name: 'Оплачена',
    textColor: '#118D57',
    color: 'success',
    // color: 'rgba(34, 197, 94, 0.16)',
    params: {
      status: 'done',
    }
  },
  rejected: {
    name: 'Отклонена',
    textColor: '#B71D18',
    color: 'errorLight',
    // color: 'rgba(255, 86, 48, 0.16)',
    params: {
      status: 'rejected',
    }
  },
  // error_rejected: {
  //   name: 'Ошибка',
  //   textColor: '#B71D18',
  //   color: 'error',
  //   params: {
  //     status: 'new',
  //   }
  // },
  error: {
    name: 'Ошибка',
    textColor: '#B71D18',
    color: 'errorLight',
    // color: 'rgba(255, 86, 48, 0.16)',
    params: {
      status: 'error',
    }
  },
  params: {
    status: 'error',
  }
}

export const bidStatusesList = [
  bidStatuses.all,
  bidStatuses.new,
  bidStatuses.on_review,
  bidStatuses.pending,
  bidStatuses.done,
  bidStatuses.rejected,
  bidStatuses.error,
]

